// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-layout__container {
  height: 100%;
}

.tab-layout__tabs-header {
  height: 50px;
}

.tab-layout__tabs-content {
  height: calc(100% - 50px);
  overflow-y: auto;
  /* Hide scrollbar */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tabs/tab-layout.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,gBAAgB;EAC1C,kBAAkB;AACpB","sourcesContent":[".tab-layout__container {\n  height: 100%;\n}\n\n.tab-layout__tabs-header {\n  height: 50px;\n}\n\n.tab-layout__tabs-content {\n  height: calc(100% - 50px);\n  overflow-y: auto;\n  /* Hide scrollbar */\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE and Edge */\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
